/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import {
  AlertController,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { PipaylibService } from 'pipaylib';
import { Order } from 'pipaylib/domain/order';
import EscPosEncoder from 'esc-pos-encoder';
import { Distyretailer } from 'pipaylib/domain/distyretailer';
import { formatDate } from '@angular/common';
import { ToWords } from 'to-words';
import { Distyconfig } from 'pipaylib/domain/distyconfig';
//import { Storage } from '@ionic/storage-angular';

export interface processinvoice {
  txnid: string;
  retailer: string;
  invoiceno: string;
  paidamount: number;
  paidon: string;
  paymentmode: string;
  bankname: string;
  remark: string;
  scanimageurl: string;
  instrumentref: string;
  chqdate: string;
  collectedby: string;
  retailermobileno: string;
  creditnotereason: string;
  credit: number;
  verifywithoutotp: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AppdataService {
  globalvars = new Map();
  curconfig: Distyconfig;
  private _storage: Storage | null = null;
  constructor(
    public alertController: AlertController,
    public pipaylib: PipaylibService,
    public toastController: ToastController,
    public loadingController: LoadingController
  ) {}

  public async getBTPrintBuffer(ord: Order) {
    const encoder = new EscPosEncoder();
    const printer = encoder.initialize();
    const cartitems = ord.cart.items;
  
    // Fetch GST configuration
    this.curconfig = this.pipaylib.loginService.loggedindistributor.distyconfig;
    const nogstinbill = this.curconfig.nogstinbill;
  
    // Define column widths
    const columnWidths = {
      name: 18,
      qty: 6,
      mrp: 7,
      rate: 7,
      amt: 10,
    };
  
    // Header: Distributor Info
    printer
      .align('center')
      .newline()
      .bold(true)
      .line(this.pipaylib.loginService.loggedindistributor.businessname)
      .bold(false)
      .line(this.pipaylib.loginService.loggedindistributor.addressline1)
      .line(this.pipaylib.loginService.loggedindistributor.mobileno)
      .line(this.pipaylib.loginService.loggedindistributor.emailid);
  
    if (!nogstinbill) {
      printer.line('GST No :' + this.pipaylib.loginService.loggedindistributor.gstinno);
    }
    printer.newline();
  
    const retailerobj = await this.pipaylib.dataService.getLiveRetailerForId(ord.distyretailerid, ord.distributorid) as Distyretailer;
    const retgstinNo = retailerobj.gstinno || '';
    const retaddress = retailerobj.addressline1 || '';
  
    // Invoice Info
    printer
      .align('center')
      .bold(true)
      .line(nogstinbill ? '---------------- INVOICE ----------------' : '---------------- TAX INVOICE ----------------')
      .bold(false)
      .newline()
      .size(0, 0)
      .align('left')
      .line('Salesman Name : ' + this.pipaylib.loginService.loggedinstaff.name)
      .line('Customer Name : ' + ord.distyretailername)
      .line(retaddress);
  
    if (!nogstinbill && retgstinNo) {
      printer.line('GST No: ' + retgstinNo);
    }
  
    printer
      .line('Invoice No: ' + ord.billseq)
      .align('right')
      .text('Date: ' + formatDate(ord.orderdate, 'dd/MM/yyyy', 'en'))
      .newline()
      .align('center')
      .text('-'.repeat(48))
      .text('Name'.padEnd(columnWidths.name))
      .text('Qty'.padStart(columnWidths.qty))
      .text('MRP'.padStart(columnWidths.mrp))
      .text('Rate'.padStart(columnWidths.rate))
      .text('Amt'.padStart(columnWidths.amt))
      .newline();
  
    if (!nogstinbill) {
      printer
        .text('HSNCode'.padEnd(columnWidths.name))
        .text(''.padStart(columnWidths.qty))
        .text(''.padStart(columnWidths.mrp))
        .text('Disc'.padStart(columnWidths.rate))
        .text(''.padStart(columnWidths.amt))
        .newline()
        .text(''.padEnd(columnWidths.name))
        .text(''.padStart(columnWidths.qty))
        .text(''.padStart(columnWidths.mrp))
        .text('Tax'.padStart(columnWidths.rate))
        .text(''.padStart(columnWidths.amt))
        .newline();
    }
  
    printer.text('-'.repeat(48));
  
    // Item Loop
    cartitems.forEach((item) => {
      const strnamerray = item.productname.match(/(.{1,18})/g) || [];
      const name1 = strnamerray[0] || item.productname;
      const name2 = strnamerray[1] || '';
      const hsn = item.hsnno ? item.hsnno : '';
      const name3 = 'HSN:' + hsn;
    
      const gst = (item.cgst ?? 0) + (item.sgst ?? 0) + (item.igst ?? 0) + (item.cess ?? 0);
    
      // Print first row: always
      printer
        .text(name1.padEnd(columnWidths.name))
        .text(item.billedquantity.toFixed(0).padStart(columnWidths.qty))
        .text(item.mrp.toFixed(2).padStart(columnWidths.mrp))
        .text(item.rate.toFixed(2).padStart(columnWidths.rate))
        .text(item.billedamount.toFixed(2).padStart(columnWidths.amt))
        .newline();
    
      if (!nogstinbill) {
        // Print HSN and Discount together in second row
        printer
          .text(name3.padEnd(columnWidths.name))
          .text(''.padStart(columnWidths.qty))
          .text(''.padStart(columnWidths.mrp))
          .text(item.disc.toFixed(2).padStart(columnWidths.rate))
          .text(''.padStart(columnWidths.amt))
          .newline();
    
        // Print Tax in third row
        if (gst > 0) {
          printer
            .text(name2.padEnd(columnWidths.name))
            .text(''.padStart(columnWidths.qty))
            .text(''.padStart(columnWidths.mrp))
            .text(gst.toFixed(2).padStart(columnWidths.rate))
            .text(''.padStart(columnWidths.amt))
            .newline();
        } else if (name2) {
          printer.text(name2.padEnd(columnWidths.name)).newline();
        }
      } else if (name2) {
        // If GST suppressed, show only second name line if available
        printer.text(name2.padEnd(columnWidths.name)).newline();
      }
    });
  
    if (!nogstinbill) {
      // Taxable Amount: only for GST invoices
      printer
        .text('-'.repeat(48))
        .align('right')
        .text('Taxable Amount: ' + ord.cart.billedamount.toFixed(2))
        .newline()
        .text('-'.repeat(48));
  
      // GST Bifurcation
      printer
        .align('left')
        .text('GST%')
        .text('CGST'.padStart(8))
        .text('SGST'.padStart(8))
        .text('IGST'.padStart(8))
        .text('CESS'.padStart(8))
        .newline()
        .text('-'.repeat(48));
  
      ord.cart.gstbifurcationlist.forEach((txitem) => {
        const cess = (txitem.gstrate === 28 && ord.cart.cess) ? ord.cart.cess : 0;
        printer
          .text(txitem.gstrate.toFixed(0).padStart(3))
          .text(txitem.cgstamount.toFixed(2).padStart(8))
          .text(txitem.sgstamount.toFixed(2).padStart(8))
          .text(txitem.igstamount.toFixed(2).padStart(8))
          .text(cess.toFixed(2).padStart(10))
          .newline();
      });
  
      printer
        .text('-'.repeat(48))
        .align('left')
        .text('Total Saving: ' + ord.cart.totaldisc.toFixed(2))
        .newline()
        .text('-'.repeat(48));
    }
  
    const payableamt = parseFloat('' + ord.cart.payableamount);
    printer
      .text('-'.repeat(48))
      .size(0, 0)
      .align('left')
      .text('Total Payable: ')
      .text(payableamt.toFixed(2).padEnd(9))
      .newline()
      .text('-'.repeat(48));
  
    // Footer with amount in words
    const toWords = new ToWords();
    printer
      .newline()
      .newline()
      .align('left')
      .size(0, 0)
      .line('Total Invoice Value (In Rupees): ')
      .line(toWords.convert(payableamt))
      .newline()
      .newline()
      .line('Customer Sign: ___________________')
      .newline()
      .newline()
      .newline()
      .line('Salesman Sign: ___________________')
      .newline()
      .newline()
      .newline()
      .cut();
  
    const resultByte = printer.encode();
    console.log('PRINT STRING ' + resultByte);
    return resultByte;
  }
  
  
  
  async getBTPrintBuffer2inch(ord: Order)
  {
    const encoder = new EscPosEncoder()
    const printer = encoder.initialize()
    const cartitems = ord.cart.items
  
    // Retrieve configuration
    this.curconfig = this.pipaylib.loginService.loggedindistributor.distyconfig;
  
    // Define column widths for 2-inch receipt
    const columnWidths = {
      name: 11, // Width for the product name
      qty: 3, // Width for Qty
      rate: 8, // Width for Rate
      total: 8, // Width for Total
    }
  
    const gstNumber = this.pipaylib.loginService.loggedindistributor.gstinno
  
    // Header with business information
    printer
      .align("center")
      .size(0.75, 0.75)
      .newline()
      .bold(true)
      .line(this.pipaylib.loginService.loggedindistributor.businessname) // Shop Name
      .bold(false)
      .line(this.pipaylib.loginService.loggedindistributor.addressline1) // Address
      .line(this.pipaylib.loginService.loggedindistributor.mobileno) // Mobile
      .line(this.pipaylib.loginService.loggedindistributor.emailid) // Email
  
    // Conditionally print GST Number
    if (gstNumber && gstNumber.length > 10) {
      printer.line("GST No: " + gstNumber) // Show GST No line only if conditions are met
    }
  
    printer.newline()
  
    const retailerobj = (await this.pipaylib.dataService.getLiveRetailerForId(
      ord.distyretailerid,
      ord.distributorid,
    )) as Distyretailer
    const retgstinNo = retailerobj.gstinno || ""
    const retaddress = retailerobj.addressline1 || ""
  
    // Print invoice info
    printer
      .align("center")
      .bold(true)
      .line("INVOICE")
      .bold(false)
      .newline()
      .align("left")
      .line("Date: " + formatDate(ord.orderdate, "dd-MM-yyyy HH:mm", "en")) // Date and time
      .line("Invoice #: " + ord.billseq) // Invoice number
      .line("Customer: " + ord.distyretailername) // Customer name
      .line(retaddress)
  
    // Conditionally print retailer GST
    if (retgstinNo) {
      printer.line("GST: " + retgstinNo)
    }
  
    printer.newline()
  
    // Print order table header
    printer
      .align("center")
      .text("-".repeat(32))
      .text("Item".padEnd(columnWidths.name))
      .text("Qty".padStart(columnWidths.qty))
      .text("Rate".padStart(columnWidths.rate))
      .text("Total".padStart(columnWidths.total))
      .newline()
      .text("-".repeat(32))
  
    // Data Rows with proper alignment
    cartitems.forEach((item) => {
      const productName = item.productname
  
      // Handle product name wrapping
      const lines = this.wrapText(productName, columnWidths.name)
  
      lines.forEach((line, index) => {
        if (index === 0) {
          // Print first line with all columns
          printer
            .text(line.padEnd(columnWidths.name))
            .text(item.billedquantity.toFixed(0).padStart(columnWidths.qty))
            .text(item.rate.toFixed(2).padStart(columnWidths.rate))
            .text(item.billedamount.toFixed(2).padStart(columnWidths.total))
            .newline()
        } else {
          // For subsequent lines, only print the name column
          printer
            .text(line.padEnd(columnWidths.name + columnWidths.qty + columnWidths.rate + columnWidths.total))
            .newline()
        }
      })
    })
  
    // Calculate totals
    const qty = cartitems.reduce((sum, item) => sum + item.billedquantity, 0)
  
    // Print totals
    printer.text("-".repeat(32)).newline()
  
    // Line for Items and SubTotal
    const totalWidth = 32 // Total width for the line
    const itemsText = `Items: ${cartitems.length}`
    const subTotalText = `SubTotal: Rs ${ord.cart.billedamount.toFixed(2)}`
    const remainingSpace1 = totalWidth - itemsText.length - subTotalText.length
  
    printer.text(itemsText + " ".repeat(remainingSpace1) + subTotalText).newline()
  
    // Line for Qty and TotalTax
    const qtyText = `Qty: ${qty}`
    const totalTaxText = `TotalTax: Rs ${(ord.cart.cgst + ord.cart.sgst + ord.cart.igst + ord.cart.cess).toFixed(2)}`
    const remainingSpace2 = totalWidth - qtyText.length - totalTaxText.length
  
    printer
      .text(qtyText + " ".repeat(remainingSpace2) + totalTaxText)
      .newline()
      .text("-".repeat(32))
  
    if (!this.curconfig.nogstinbill) {
      // Tax Details Table
      printer
        .align("center")
        .bold(true)
        .text("Tax Details")
        .bold(false)
        .newline()
        .text("-".repeat(32))
        .text("Taxable Amt".padEnd(15) + "Rate".padEnd(10) + "Tax Amt".padEnd(7))
        .newline()
        .text("-".repeat(32))
  
      cartitems.forEach((item) => {
        const taxableAmount = item.billedamount.toFixed(2) // Taxable amount
        const taxRate = item.gstrate ? item.gstrate + "%" : "0%" // Tax rate
        const taxAmount = ((item.cgst ?? 0) + (item.sgst ?? 0) + (item.igst ?? 0) +(item.cess ?? 0)).toFixed(2) // Tax amount
  
        const formattedLine = taxableAmount.padEnd(15) + taxRate.padEnd(10) + taxAmount.padStart(7)
  
        printer.text(formattedLine).newline()
      })
  
      printer.text("-".repeat(32)).newline()
    }
  
    // Footer
    printer
      .align("center")
      .bold(true)
      .text("Total: Rs " + ord.cart.payableamount.toFixed(2))
      .bold(false)
      .newline()
      .text("You saved Rs " + ord.cart.totaldisc.toFixed(2))
      .newline()
      .text("-".repeat(32))
      .newline()
      .newline()
      .newline()
      .cut()
  
    // Encode and return result
    const resultByte = printer.encode()
    console.log("PRINT STRING:", resultByte)
    return resultByte;
  }
  
  // Helper function for wrapping text
  wrapText(text: string, maxWidth: number): string[]
  {
    const words = text.split(" ")
    const lines: string[] = []
    let currentLine = ""
  
    words.forEach((word) => {
      if (currentLine.length + word.length + 1 > maxWidth) {
        if (currentLine.length) {
          lines.push(currentLine.trim())
          currentLine = ""
        }
        while (word.length > maxWidth) {
          lines.push(word.slice(0, maxWidth))
          word = word.slice(maxWidth)
        }
        currentLine = word + " "
      } else {
        currentLine += word + " "
      }
    })
  
    if (currentLine.trim().length > 0) {
      lines.push(currentLine.trim())
    }
  
    return lines;
  }
  
  




  
  public async displayToast(
    msg: string,
    alerttype: string,
    position?: 'top' | 'bottom' | 'middle'
  ) {
    let stricon;
    let strcssclass;

    if (alerttype === 'SUCCESS') {
      stricon = 'checkmark-circle';
      strcssclass = 'success-toast';
    } else if (alerttype === 'FAIL') {
      stricon = 'ban';
      strcssclass = 'fail-toast';
    } else if (alerttype === 'WARNING') {
      stricon = 'warning';
      strcssclass = 'warning-toast';
    }

    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      cssClass: strcssclass,
      position: position ? position : 'bottom',
      buttons: [
        {
          side: 'start',
          icon: stricon,
        },
      ],
    });
    toast.present();
  }

  // Simple loader
  simpleLoader(message?) {
    let strmsg = 'Loading..';
    if (message) {
      strmsg = message;
    }

    this.loadingController
      .create({
        message: strmsg,
      })
      .then((response) => {
        response.present();
      });
  }

  // Dismiss loader
  dismissLoader() {
    this.loadingController
      .dismiss()
      .then((response) => {
        //console.log('Loader closed!', response);
      })
      .catch((err) => {
        //console.log('Error occured : ', err);
      });
  }

  convertImageToBase64(imagePath: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      // Create a new Image object
      const img = new Image();

      // Set the image source
      img.src = imagePath;

      // When the image is loaded, draw it onto a canvas
      img.onload = () => {
        // Create a canvas element
        const canvas = document.createElement('canvas');

        // Set canvas dimensions to match the image
        canvas.width = img.width;
        canvas.height = img.height;

        // Get the drawing context
        const ctx = canvas.getContext('2d');

        // Draw the image onto the canvas
        ctx.drawImage(img, 0, 0);

        // Get the base64 representation of the image
        const base64 = canvas.toDataURL('image/png');

        // Resolve the promise with the base64 string
        resolve(base64);
      };

      // Handle errors
      img.onerror = (error) => {
        reject(error);
      };
    });
  }

  getInvoiceNumber(invoice: string): string {
    if (!invoice) return '';
    const curconfig = this.pipaylib.loginService.loggedindistributor.distyconfig;
    // Check if appendfinancialyear is true
    if (curconfig?.alliedconfig?.appendfinancialyear) {
      const parts = invoice.split('-');
      return parts[parts.length - 1]; // Return the last part after splitting
    }
    
    // If appendfinancialyear is false, return the invoice as is
    return invoice;
  }

  /*async init() {
    console.log('storage init')
    const storage = await this.storage.create();
    this._storage = storage;
  }

  public async set(key: string, value: any) {
    console.log('storage set')
    let result = await this._storage?.set(key, value);
    // console.log(result)
  }

  public async get(key: string) {
    console.log('storage get')
    let value = await this._storage?.get(key);
    // console.log(value);
    return value
  }

  public async remove(key:string) {
    let value = await this._storage?.remove(key);
  }

  public async clear() {
    let value = await this._storage?.clear();
  }

  public async keys(key:string) {
    let value = await this._storage?.keys();
    return value
  }*/
}
 // Helper function to wrap text



